import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, Row, Spin, Table, Tag, Empty, message } from "antd";
import { ReloadOutlined, CheckCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import { DynamicCardForm, ButtonItem } from "../../../../Components/Items";
import FiltroIngenieroCMMS, { esperarFiltroDefault } from "../componentes/FiltroIngenieroCMMS";
import { Medidor } from "../componentes/IndicadoresCMMS";
import { cmmsPost, formatoFecha, formatoPorcentaje, estatusServicio } from "../cmmsComun";
import "../cmms.css";

// Inicio del CMMS: lo que hay que atender hoy. Cada tarjeta lleva a su pantalla. Es el mismo
// calculo del aviso diario que llega como notificacion (y por correo si se configuro).

const fechaLarga = (k) => moment(k, "YYYY-MM-DD").format("dddd D [de] MMMM");

// Tarjeta de indicador clicable; `alerta` pinta la cifra cuando hay algo que atender.
const Indicador = ({ titulo, valor, detalle, alerta, onClick }) => (
    <div className={`cmms-tile cmms-tile-clic ${alerta && valor ? "cmms-tile-alerta" : ""}`} onClick={onClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && onClick?.()}>
        <div className="cmms-tile-titulo">{titulo}</div>
        <div className="cmms-tile-valor">{valor}</div>
        {detalle ? <div className="cmms-tile-detalle">{detalle}</div> : null}
    </div>
);

const Vacio = ({ texto }) => (
    <div className="cmms-inicio-vacio">
        <CheckCircleOutlined /> {texto}
    </div>
);

class InicioCMMS extends Component {
    state = { cargando: false, empleadoId: null, r: null };

    componentDidMount() {
        esperarFiltroDefault(this).then(() => this.consultar());
    }

    consultar = async () => {
        this.setState({ cargando: true });
        try {
            const res = await cmmsPost(this.props, "inicioCMMS", { empleadoId: this.state.empleadoId });
            if (res.data.success === 2) this.setState({ r: res.data.resumen });
            else message.error(res.data.message || "No se pudo consultar");
        } catch (error) {
            console.log(error);
            message.error("No se pudo consultar");
        } finally {
            this.setState({ cargando: false });
        }
    };

    ir = (ruta, estado) => this.props.history.push(ruta, estado);

    render() {
        const r = this.state.r;
        return (
            <div className="cmms-pagina">
                <PageHeader
                    title="Inicio"
                    subTitle={r ? `Lo que hay que atender · ${fechaLarga(r.hoy)}` : "Lo que hay que atender hoy"}
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                    extra={
                        <ButtonItem blanco botonAncho icon={<ReloadOutlined />} onClick={this.consultar}>
                            Actualizar
                        </ButtonItem>
                    }
                />
                <div className="cmms-filtros">
                    <FiltroIngenieroCMMS {...this.props} width={300} placeholder="Todos los ingenieros" value={this.state.empleadoId} onChange={(empleadoId) => this.setState({ empleadoId }, this.consultar)} />
                    <span className="cmms-ayuda" style={{ margin: 0 }}>
                        Con un ingeniero se ve lo suyo y lo que no tiene ingeniero (es para todos).
                    </span>
                </div>
                <Spin spinning={this.state.cargando}>{r ? this.renderResumen(r) : <div style={{ height: 300 }} />}</Spin>
            </div>
        );
    }

    renderResumen(r) {
        const urgentes = r.tickets.porPrioridad.find((p) => p.prioridad === 1)?.n || 0;
        return (
            <>
                <div className="cmms-tiles">
                    <Indicador
                        titulo="Tickets abiertos"
                        valor={r.tickets.abiertos}
                        alerta={urgentes > 0 || r.tickets.sinAsignar > 0}
                        detalle={`${urgentes} urgentes · ${r.tickets.sinAsignar} sin ingeniero`}
                        onClick={() => this.ir("/panel/cmmsTickets")}
                    />
                    <Indicador
                        titulo="Servicios de hoy"
                        valor={r.servicios.hoy.length}
                        detalle={`${r.servicios.enProceso} en proceso · ${r.servicios.programados} programados`}
                        onClick={() => this.ir("/panel/cmmsServicios")}
                    />
                    <Indicador
                        titulo="Agenda de hoy"
                        valor={r.agenda.hoy}
                        detalle={`${r.agenda.semana} en la semana · ${r.agenda.atrasados} atrasados`}
                        alerta={r.agenda.atrasados > 0}
                        onClick={() => this.ir("/panel/cmmsAgenda")}
                    />
                    <Indicador
                        titulo="Preventivos vencidos"
                        valor={r.preventivos.vencidos}
                        alerta
                        detalle={`${r.preventivos.porVencer} vencen en ${r.preventivos.diasPorVencer} días`}
                        onClick={() => this.ir("/panel/cmmsAgenda")}
                    />
                    <Indicador
                        titulo="Contratos por renovar"
                        valor={r.contratos.porRenovar.length}
                        alerta
                        detalle={`${r.contratos.vigentes} vigentes`}
                        onClick={() => this.ir("/panel/cmmsContratos")}
                    />
                    <Indicador
                        titulo="Certificados por vencer"
                        valor={r.certificados.porVencer}
                        alerta
                        detalle={`${r.patrones.vencidos.length + r.patrones.porVencer.length} equipos patrón por calibrar`}
                        onClick={() => this.ir("/panel/cmmsCertificados")}
                    />
                    <Indicador titulo="De viaje hoy" valor={r.viajes.hoy.length} detalle={`${r.viajes.semana} viajes en la semana`} onClick={() => this.ir("/panel/cmmsViajes")} />
                    <Indicador titulo="Concluidos en el mes" valor={r.servicios.concluidosMes} detalle="Órdenes de Servicio" onClick={() => this.ir("/panel/cmmsServicios")} />
                </div>
                <Row gutter={14}>
                    <DynamicCardForm title={`Tickets urgentes (${r.tickets.urgentes.length})`} xs={24} lg={12}>
                        {r.tickets.urgentes.length ? (
                            r.tickets.urgentes.map((t) => (
                                <div key={t._id} className="cmms-inicio-renglon" onClick={() => this.ir("/panel/cmmsTickets")}>
                                    <div>
                                        <b>{t.codigo}</b> · {t.clienteNombre || "Sin cliente"}
                                        <div className="cmms-agenda-item-sub">{t.solicitud}</div>
                                    </div>
                                    {t.ingeniero ? <span className="cmms-agenda-item-sub">{t.ingeniero}</span> : <Tag color="red">Sin ingeniero</Tag>}
                                </div>
                            ))
                        ) : (
                            <Vacio texto="Ningún ticket urgente abierto" />
                        )}
                    </DynamicCardForm>
                    <DynamicCardForm title={`Servicios de hoy (${r.servicios.hoy.length})`} xs={24} lg={12}>
                        {r.servicios.hoy.length ? (
                            r.servicios.hoy.map((s) => (
                                <div key={s._id} className="cmms-inicio-renglon" onClick={() => this.ir("/panel/cmmsServicio", { id: s._id })}>
                                    <div>
                                        <b>{s.codigo}</b> · {s.activoTexto}
                                        <div className="cmms-agenda-item-sub">{[s.clienteNombre, s.ingeniero].filter(Boolean).join(" · ")}</div>
                                    </div>
                                    <Tag color={estatusServicio(s.estatus).color}>{estatusServicio(s.estatus).label}</Tag>
                                </div>
                            ))
                        ) : (
                            <Vacio texto="Ninguna Orden de Servicio para hoy" />
                        )}
                    </DynamicCardForm>
                    <DynamicCardForm title="Avance de las vueltas en curso" xs={24}>
                        <div className="cmms-ayuda">La vuelta que corre hoy en cada contrato vigente. “Atrasada” = va por debajo de lo que llevaría con un avance parejo.</div>
                        <Table
                            size="small"
                            rowKey={(x) => `${x.contratoId}${x.vuelta}`}
                            pagination={false}
                            dataSource={r.contratos.vueltas}
                            locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Ninguna vuelta en curso" /> }}
                            onRow={(x) => ({ onClick: () => this.ir("/panel/cmmsContrato", { id: x.contratoId }), style: { cursor: "pointer" } })}
                            columns={[
                                { title: "Contrato", dataIndex: "contratoNombre" },
                                { title: "Vuelta", dataIndex: "vuelta", width: 120 },
                                { title: "Termina", dataIndex: "fechaFin", width: 150, render: (v, x) => `${formatoFecha(v)} (${x.diasRestantes} días)` },
                                { title: "Realizados", width: 110, align: "right", render: (x) => `${x.realizados} de ${x.total}` },
                                {
                                    title: "Avance",
                                    width: 230,
                                    render: (x) => (
                                        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                                            <div style={{ flex: 1 }}>
                                                <Medidor valor={x.avance} />
                                            </div>
                                            {x.avance !== null && x.avance < x.esperado - 0.1 ? <Tag color="orange">Atrasada</Tag> : null}
                                        </div>
                                    ),
                                },
                                { title: "Esperado hoy", dataIndex: "esperado", width: 110, align: "right", render: formatoPorcentaje },
                            ]}
                        />
                    </DynamicCardForm>
                    <DynamicCardForm title={`Contratos por renovar (${r.contratos.porRenovar.length})`} xs={24} lg={12}>
                        {r.contratos.porRenovar.length ? (
                            r.contratos.porRenovar.map((c) => (
                                <div key={c._id} className="cmms-inicio-renglon" onClick={() => this.ir("/panel/cmmsContrato", { id: c._id })}>
                                    <div>
                                        <b>{c.nombre}</b>
                                        <div className="cmms-agenda-item-sub">{c.clienteNombre}</div>
                                    </div>
                                    <Tag color="gold">
                                        {formatoFecha(c.fechaConclusion)} · {c.diasRestantes} días
                                    </Tag>
                                </div>
                            ))
                        ) : (
                            <Vacio texto="Ningún contrato por renovar" />
                        )}
                    </DynamicCardForm>
                    <DynamicCardForm title="Certificados y equipos patrón" xs={24} lg={12}>
                        {r.certificados.lista.length || r.patrones.vencidos.length || r.patrones.porVencer.length ? (
                            <>
                                {r.patrones.vencidos.map((p, i) => (
                                    <div key={`pv${i}`} className="cmms-inicio-renglon" onClick={() => this.ir("/panel/cmmsCertificados")}>
                                        <div>
                                            <b>{p.nombre}</b> {p.serie ? `· ${p.serie}` : ""}
                                            <div className="cmms-agenda-item-sub">Equipo patrón</div>
                                        </div>
                                        <Tag color="red">Calibración vencida {formatoFecha(p.proximaCalibracion)}</Tag>
                                    </div>
                                ))}
                                {r.patrones.porVencer.map((p, i) => (
                                    <div key={`pp${i}`} className="cmms-inicio-renglon" onClick={() => this.ir("/panel/cmmsCertificados")}>
                                        <div>
                                            <b>{p.nombre}</b> {p.serie ? `· ${p.serie}` : ""}
                                            <div className="cmms-agenda-item-sub">Equipo patrón</div>
                                        </div>
                                        <Tag color="gold">Calibrar antes del {formatoFecha(p.proximaCalibracion)}</Tag>
                                    </div>
                                ))}
                                {r.certificados.lista.map((c) => (
                                    <div key={c._id} className="cmms-inicio-renglon" onClick={() => this.ir("/panel/cmmsCertificados")}>
                                        <div>
                                            <b>{c.codigo}</b> · {c.nombre}
                                            <div className="cmms-agenda-item-sub">{[c.equipo, c.clienteNombre].filter(Boolean).join(" · ")}</div>
                                        </div>
                                        <Tag color="gold">Vence {formatoFecha(c.vigenciaHasta)}</Tag>
                                    </div>
                                ))}
                                {r.certificados.porVencer > r.certificados.lista.length ? (
                                    <div className="cmms-agenda-item-sub" style={{ marginTop: 6 }}>
                                        y {r.certificados.porVencer - r.certificados.lista.length} certificados más por vencer
                                    </div>
                                ) : null}
                            </>
                        ) : (
                            <Vacio texto="Nada por vencer en los próximos 30 días" />
                        )}
                    </DynamicCardForm>
                    <DynamicCardForm title={`De viaje hoy (${r.viajes.hoy.length})`} xs={24}>
                        {r.viajes.hoy.length ? (
                            r.viajes.hoy.map((v) => (
                                <div key={v._id} className="cmms-inicio-renglon" onClick={() => this.ir("/panel/cmmsViajes")}>
                                    <div>
                                        <b>{v.destino || "Viaje"}</b>
                                        <div className="cmms-agenda-item-sub">{v.personal}</div>
                                    </div>
                                    {v.cancelaComedor ? <Tag color="gold">Cancela comedor</Tag> : null}
                                </div>
                            ))
                        ) : (
                            <Vacio texto="Nadie de viaje hoy" />
                        )}
                    </DynamicCardForm>
                </Row>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(InicioCMMS);
